import React from 'react';
import { ActivityIcon, PillIcon, UsersIcon, PackageIcon } from 'lucide-react';
export function App() {
  return <div className="min-h-screen bg-slate-950 text-slate-50 flex flex-col items-center justify-center p-6 text-center" data-id="element-0">
      <div className="max-w-2xl space-y-8" data-id="element-1">
        <div className="flex justify-center" data-id="element-2">
          <div className="p-4 bg-sky-500/10 rounded-2xl border border-sky-500/20" data-id="element-3">
            <ActivityIcon className="w-12 h-12 text-sky-400" data-id="element-4" />
          </div>
        </div>

        <div className="space-y-4" data-id="element-5">
          <h1 className="text-4xl font-bold tracking-tight sm:text-6xl" data-id="element-6">
            Pharmacy <span className="text-sky-400 text-pulse" data-id="element-7">Pulse</span>
          </h1>
          <p className="text-lg text-slate-400 max-w-lg mx-auto" data-id="element-8">
            Project initialized. A sophisticated, data-driven platform for
            modern pharmacy operations.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-8" data-id="element-9">
          {[{
          icon: PillIcon,
          label: 'Prescriptions'
        }, {
          icon: PackageIcon,
          label: 'Inventory'
        }, {
          icon: UsersIcon,
          label: 'Patients'
        }].map((item, i) => <div key={i} className="p-4 bg-slate-900/50 border border-slate-800 rounded-xl flex flex-col items-center gap-2" data-id="element-10">
              <item.icon className="w-5 h-5 text-slate-400" data-id="element-11" />
              <span className="text-sm font-medium text-slate-300" data-id="element-12">
                {item.label}
              </span>
            </div>)}
        </div>

        <div className="pt-8" data-id="element-13">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-900 border border-slate-800 text-xs font-medium text-slate-400" data-id="element-14">
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-15" />
            System Ready
          </div>
        </div>
      </div>
    </div>;
}